<template>
  <section class="ps-table-wrap">
    <ve-table
      :fixed-header="true"
      max-height="100%"
      :columns="columns"
      :table-data="tableData"
      :border-around="false"
      :sort-option="sortOption"
    />
  </section>
</template>

<script>
import { VeTable } from 'vue-easytable';

export default {
    components:{
        VeTable,
    },
    props:{
        order_items:{
            type: Array,
            default: () => []
        },
        cols: {
            type: Array,
            default: () => [],
        },
        summary: {
            type: Object,
            default: () => ({}),
        },
    },
    data(){
        return {
          sortConfig: {},
          sortOption: {
            sortAlways: true,
            sortChange: params => this.$emit('on-sort-change', params),
          },
        }
    },
    computed:{
        tableData(){
            if (!this.order_items?.length) {
                return [];
            }

            const sumRows = [
                {
                item_price: "Grand Total",                        // at 'item_price' column display text 'Grand Total'
                total: parseFloat(this.summary?.grantTotal?.toFixed(2)),          // at 'total' column display grantTotal amount
                isTitle: true,
                class:"font_600"
              },
              {
                item_price: "Discount",                          // at 'item_price' column display text 'SST'
                total: "- " + (this.summary.discount_total ?? 0).toFixed(2),           // at 'total' column display sst amount
                isTitle: true,
                class:"font_500",
              },
              {
                item_price: "SST",                          // at 'item_price' column display text 'SST'
                total: parseFloat(this.summary.sst?.toFixed(2)),           // at 'total' column display sst amount
                isTitle: true,
                class:"font_500"
              },
              {
                item_price: "Paid Amount",
                total: parseFloat((this.summary.paid_total || 0).toFixed(2)),
                isTitle: true,
                isPayMessage: true,
                class:"font_500"
              },
              {
                item_price: "Balance",                        // at 'item_price' column display text 'Total'
                total: parseFloat(this.summary.balance?.toFixed(2)),      // at 'total' column display sum amount
                isTitle: true,
                class:"font_500"
              },
            ]

            return [
                ...this.order_items,
                ...sumRows,
            ];
        },
        columns(){
            let matches = {};

            matches.item_name = {
                field: 'item_name',
                key: 'item_name',
                title: 'Item',
                // fixed: 'left',
                align: 'left',
                // width: 120,
                renderBodyCell: ({row,rowIndex })=>{
                    return <span>{row.display_title}</span>
                }
            }
            matches.item_price = {
                field: 'item_price',
                key: 'item_price',
                title: `Unit Price`,
                currency: this.order?.currency,
                align: 'right',
                // width: 80,
                renderBodyCell: ({row,rowIndex})=>{
                    const price = typeof row.item_price === "number"
                    ? row.item_price.toFixed(2) : row.item_price;
                    if (row.isTitle) {
                      return <span class={["order_edit_tbl_title",row.class].join(" ")}>{price}</span>
                    }

                    return <span class={row.isTitle ? "order_edit_tbl_title":""}>{price}</span>
                },
                renderHeaderCell:({ column })=>{
                    return <span class="order_head_col">
                        <span>{column.title}</span>
                        <span class="order_head" style="width:100%">({this.summary.currency})</span>
                    </span>
                }
            }
            matches.quantity = {
                field: 'quantity',
                key: 'quantity',
                title: 'Quantity',
                align: 'right',
                // width: 80,
                renderBodyCell: ({row, rowIndex })=>{
                  // console.log({rowIndex });
                    return <span>{row.orderQuantity}</span>
                }
            }
            matches.total = {
                field: 'total',
                key: 'total',
                title: `Total`,
                currency: this.order?.currency,
                align: 'right',
                // width: 100,
                renderBodyCell: ({row})=>{
                  const price = typeof row.total === "number"
                    ? row.total.toFixed(2) : row.total;
                    return <span class={row.isTitle ? "order_edit_tbl_title " + row.class:""}>
                      {price}
                    </span>
                },
            }

            const preSet = [];
            this.cols.forEach(col=>{
                if (col.visible) {
                    if (col.key in matches) {
                        preSet.push(matches[col.key])
                    }
                }
            })
            return preSet;
        },
    },
}
</script>


<style lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_ps_table.scss';

</style>